import React from "react";
import { Tooltip, Grid } from "@mui/material";

const ForceCheckoutIcon = () => {
  const [isShown, setIsShown] = React.useState(false);
  return (
    <>
      <Tooltip title="Checkout">
        <Grid
          onMouseEnter={() => setIsShown(true)}
          onMouseLeave={() => setIsShown(false)}
        >
          {isShown ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              id="Component_870_1"
              data-name="Component 870 – 1"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <g
                id="Group_15852"
                data-name="Group 15852"
                transform="translate(-831 -156)"
              >
                <rect
                  id="Rectangle_9541"
                  data-name="Rectangle 9541"
                  width="24"
                  height="24"
                  rx="4"
                  transform="translate(831 156)"
                  fill="#f4f4f4"
                  opacity="0"
                />
                <path
                  id="Path_30361"
                  data-name="Path 30361"
                  d="M16279.935,16217.422a.894.894,0,0,1-.893-.895l-.043-16.564a.9.9,0,0,1,.783-.893.837.837,0,0,1,.334-.068h12.936a.834.834,0,0,1,.838.83v5.006a.839.839,0,1,1-1.678,0v-4.164h-6.891l2.752.816a.894.894,0,0,1,.9.895l0,13.291h3.242v-4.131a.839.839,0,0,1,1.678,0v4.969a.837.837,0,0,1-.838.836h-4.082l0,.76a.9.9,0,0,1-.9.893Zm15.084-6.127a.839.839,0,0,1,.008-1.187l1.107-1.094h-5.373a.839.839,0,0,1,0-1.678h5.328l-1.055-1.033a.834.834,0,1,1,1.164-1.2l2.549,2.479a.857.857,0,0,1,.254.6.842.842,0,0,1-.25.594l-2.547,2.523a.844.844,0,0,1-1.186-.006Z"
                  transform="translate(-15445.999 -16041.002)"
                  fill="#6b6e71"
                />
              </g>
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              id="Component_870_1"
              data-name="Component 870 – 1"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <g
                id="Group_15852"
                data-name="Group 15852"
                transform="translate(-831 -156)"
              >
                <rect
                  id="Rectangle_9541"
                  data-name="Rectangle 9541"
                  width="24"
                  height="24"
                  rx="4"
                  transform="translate(831 156)"
                  fill="#f4f4f4"
                  opacity="0"
                />
                <path
                  id="Path_30361"
                  data-name="Path 30361"
                  d="M16279.935,16217.422a.894.894,0,0,1-.893-.895l-.043-16.564a.9.9,0,0,1,.783-.893.837.837,0,0,1,.334-.068h12.936a.834.834,0,0,1,.838.83v5.006a.839.839,0,1,1-1.678,0v-4.164h-6.891l2.752.816a.894.894,0,0,1,.9.895l0,13.291h3.242v-4.131a.839.839,0,0,1,1.678,0v4.969a.837.837,0,0,1-.838.836h-4.082l0,.76a.9.9,0,0,1-.9.893Zm15.084-6.127a.839.839,0,0,1,.008-1.187l1.107-1.094h-5.373a.839.839,0,0,1,0-1.678h5.328l-1.055-1.033a.834.834,0,1,1,1.164-1.2l2.549,2.479a.857.857,0,0,1,.254.6.842.842,0,0,1-.25.594l-2.547,2.523a.844.844,0,0,1-1.186-.006Z"
                  transform="translate(-15445.999 -16041.002)"
                  fill="#6b6e71"
                />
              </g>
            </svg>
          )}
        </Grid>
      </Tooltip>
    </>
  );
};
export default ForceCheckoutIcon;
